import Form from 'antd/es/form';
import Input from 'antd/es/input';
import Typography from 'antd/es/typography';
import React from 'react';
import { styled } from 'styled-components';

import type {
  ClauseExtractionAgentBlockConfig,
  PipelineBlock,
} from '@mai/types';

const { TextArea } = Input;

const EditorContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.marginMD}px;
`;

const EditorLabel = styled(Typography.Text)`
  font-weight: 600;
  margin-bottom: ${({ theme }) => theme.marginXXS}px;
`;

const EditorHelp = styled(Typography.Text)`
  color: ${({ theme }) => theme.colorTextSecondary};
  font-size: ${({ theme }) => theme.fontSizeSM}px;
  margin-bottom: ${({ theme }) => theme.marginXS}px;
`;

interface ClauseExtractionBlockEditorProps {
  block: PipelineBlock & { type: 'clause_extraction_agent' };
  onConfigChange: (config: ClauseExtractionAgentBlockConfig) => void;
}

export const ClauseExtractionBlockEditor: React.FC<
  ClauseExtractionBlockEditorProps
> = ({ block, onConfigChange }) => {
  const [form] = Form.useForm();

  // Initialize form with current values
  React.useEffect(() => {
    form.setFieldsValue({
      instructions: block.config.instructions || '',
    });
  }, [block.config, form]);

  const handleValuesChange = (
    _: unknown,
    allValues: Partial<ClauseExtractionAgentBlockConfig>,
  ) => {
    onConfigChange({
      ...block.config,
      ...allValues,
    });
  };

  return (
    <EditorContainer>
      <Form
        form={form}
        layout="vertical"
        size="small"
        onValuesChange={handleValuesChange}
      >
        <Form.Item
          label={<EditorLabel>Instructions</EditorLabel>}
          name="instructions"
          rules={[
            { required: true, message: 'Instructions are required' },
            { min: 1, message: 'Instructions cannot be empty' },
          ]}
        >
          <TextArea
            placeholder="Provide instructions for the clause extraction LLM to guide analysis and assessment..."
            rows={4}
            showCount
          />
        </Form.Item>

        <EditorHelp>
          Instructions for the clause extraction LLM to guide analysis and
          assessment of clause presence and compliance.
        </EditorHelp>
      </Form>
    </EditorContainer>
  );
};
